export default __webpack_public_path__ + "static/media/X.efdbf131.svg";